import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DbService } from './db.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  constructor(public httpClient: HttpClient, public db: DbService) {}

  sendPush(pushId: string, title: string, message: string, type: string, id: string, chatUser?, chatType?, data?) {
    let pushIds = [];
    pushIds.push(pushId);

    return new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };
      if (chatUser) {
        let userId = chatUser;

        let payload = {
          app_id: '755c0e88-f3e4-467f-a1da-3223991078b1',
          contents: { en: message },
          headings: { en: title },
          include_player_ids: pushIds,
          data: { type, id, userId, chatType },
          android_channel_id: '851762a8-b175-41aa-bc67-cfa0a1f48c1d',
        };
        this.httpClient.post('https://onesignal.com/api/v1/notifications', payload, httpOptions).subscribe(
          new_data => {
            console.log('new_data', new_data);
            resolve(new_data);
          },
          error => {
            console.log('Err', error);
            reject(error);
          }
        );
      } else {
        let payload = {
          app_id: '755c0e88-f3e4-467f-a1da-3223991078b1',
          contents: { en: message },
          headings: { en: title },
          include_player_ids: pushIds,
          data: { type, id },
          android_channel_id: '851762a8-b175-41aa-bc67-cfa0a1f48c1d',
        };
        this.httpClient.post('https://onesignal.com/api/v1/notifications', payload, httpOptions).subscribe(
          new_data => {
            console.log('new_data', new_data);
            resolve(new_data);
          },
          error => {
            console.log('Err', error);
            reject(error);
          }
        );
      }
    });
  }

  saveTokenToFirestore(token: any) {
    if (!token) return;
    let myUid = localStorage.getItem('userId');

    const devicesRef = this.db.updateAt(`company/${myUid}`, { pushId: token.userId }).then(() => {
      console.log('PUSH ID SAVE', JSON.stringify(token));
    });
  }

  interferencModeChk(type: string, userId: string, title: string, message: string, root: string, id: string, chatUser?, chatType?) {
    this.db
      .doc$(`users/${userId}`)
      .pipe(take(1))
      .subscribe((user: any) => {
        if (user.marketing) {
          if (user && user.pushId && user.disturbanceSwitch) {
            if (user.disturbanceStart && user.disturbanceEnd) {
              const startHours = Number(user.disturbanceStart.split(':')[0]);
              const startMinutes = Number(user.disturbanceStart.split(':')[1]);

              const endHours = Number(user.disturbanceEnd.split(':')[0]);
              const endMinutes = Number(user.disturbanceEnd.split(':')[1]);

              const now = new Date();
              const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startHours, startMinutes, 0);
              const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endHours, endMinutes, 0);

              if (now.getTime() > startDate.getTime() && now.getTime() < endDate.getTime()) {
              } else {
                if (chatUser) {
                  this.sendPush(user.pushId, title, message, root, id, chatUser, chatType);
                } else {
                  this.sendPush(user.pushId, title, message, root, id);
                }
              }
            }
          } else {
            if (chatUser) {
              this.sendPush(user.pushId, title, message, root, id, chatUser, chatType);
            } else {
              this.sendPush(user.pushId, title, message, root, id);
            }
          }
        }
      });
  }
}
